<template>
  <div class="authServer">
    <!-- <SearchForm :searchConfig="searchConfig" @callBackAction="callBackAction" /> -->
    <Table
      ref="child"
      :tableConfig="tableConfig"
      :tableData="tableData"
      @callBackAction="callBackAction"
      :api="api"
      :type="type"
      :tableHeight="tableHeight"
    />
    <Drawer
      v-if="showMemberDrawer"
      :showMemberDrawer="showMemberDrawer"
      @changeMemberDrawer="changeMemberDrawer"
      :drawerMode="drawerMode"
      :formData="formData"
      @addoredit="addoredit"
      :type="type"
      :addoreditForm="addoreditForm"
      :drawerTitle="drawerTitle"
      @deleteResourceGroup="deleteResourceGroup"
      @addResourceGroup="addResourceGroup"
    />
    <Dialog
      :dialogFormVisible="dialogFormVisible"
      @setDialog="setDialog"
      :dialogType="dialogType"
      :dialogTitle="dialogTitle"
      :eventType="eventType"
      :addType="addType"
      :tableData="tableData2"
      :tableConfig="tableConfig2"
      @queryResourceGroup="queryResourceGroup"
    />
    <ConnectGroup
      @confirmConnect="confirmConnect"
      v-if="showConnectDrawer"
      :drawerType="drawerType"
      :showDrawer="showConnectDrawer"
      @changeConnectDrawer="changeConnectDrawer"
      :drawerMode="drawerMode"
      @addoredit="addoredit"
      :type="type"
      :addoreditForm="addoreditForm"
      :drawerTitle="drawerTitle"
      @addResourceGroup="addResourceGroup"
      :handelNode="handelNode"
    />
  </div>
</template>

<script>
// import SearchForm from "@/components/searchForm/index.vue";
import Table from "@/components/table/index.vue";
// import Drawer from "@/components/rightDrawer/index.vue";
import Drawer from "./drawer.vue";
import Dialog from "@/components/dialog/index.vue";
import ConnectGroup from "../organization/connectGroupDrawer.vue";
import {
  queryMember,
  deleteMember,
  queryMemberDetail,
  updateUser,
  addUser,
} from "@/api/authorization.js";

export default {
  components: { Table, Drawer, Dialog, ConnectGroup },
  data() {
    return {
      drawerType: "",
      tableHeight: document.documentElement.clientHeight - 250,
      formInline: {},
      selectedItems: [],
      eventType: "",
      dialogTitle: this.$t("common.alert"),
      dialogType: "yellowType",
      dialogFormVisible: false,
      drawerTitle: "",
      addoreditForm: {},
      formData: {},
      type: "member",
      tableData2: {},
      tableConfig2: {},
      showMemberDrawer: false,
      addType: "",
      api: {},
      handelNode: {},
      showConnectDrawer: false,
      tableData: {},
      searchConfig: {},
      drawerMode: "", //edit
      tableConfig: {
        form: {
          params: [
            {
              type: "input",
              model: "inputKey",
              placeholder: `common.inputKey`,
            },
          ],
          actions: [
            {
              type: "query",
              name: "common.query",
              event: "query",
              auth: "user_query",
            },
            { type: "add", name: "common.add", event: "add", auth: "user_add" },
            {
              type: "edit",
              name: "common.edit",
              event: "edit",
              auth: "user_edit",
            },
            {
              type: "remove",
              name: "common.remove",
              event: "remove",
              auth: "user_delete",
            },
            {
              type: "connectResourceGroup",
              name: "common.connectResourceGroup",
              event: "connectResourceGroup",
              auth: "user_relgroup_add",
            },
            {
              type: "export",
              name: "common.exportMember",
              event: "export",
              auth: "user_export",
            },
          ],
        },
        table: {
          selection: true,
          columns: [
            {
              prop: "userId",
              label: "authorization.member.userId",
              width: "",
            },
            {
              prop: "userName",
              label: "authorization.member.userName",
              width: "",
            },
            {
              prop: "userRole",
              label: "authorization.member.userRole",
              width: "",
            },
            {
              prop: "updateUser",
              label: "authorization.member.lastUpdater",
              minWidth: "150px",
            },
            {
              prop: "updateTime",
              label: "authorization.member.lastUpdateTime",
              minWidth: "150px",
            },
            { prop: "status", label: "common.status", width: "" },
          ],
          action: {},
        },
      },
      addForm: {
        userInfo: [
          {
            prop: "userId",
            label: `authorization.member.userId`,
            width: "180",
            required: true,
          },
          {
            prop: "userName",
            label: `authorization.member.userName`,
            width: "180",
            required: true,
          },
          {
            prop: "rootOrgCode",
            label: `authorization.member.rootOrgCode`,
            width: "180",
            required: true,
            disabled: true,
          }, //qcc
          {
            prop: "parentOrgCode",
            label: `authorization.member.parentOrgCode`,
            width: "180",
            required: true,
          }, //qcc
          {
            prop: "branchCode",
            label: `authorization.member.branchCode`,
            width: "180",
            required: false,
          },
          {
            prop: "userRole",
            label: `authorization.member.userRole`,
            width: "180",
            required: false,
          },
          {
            prop: "contactNo",
            label: `authorization.member.contactNo`,
            width: "180",
            required: false,
          },
          {
            prop: "email",
            label: `authorization.member.email`,
            width: "180",
            required: false,
          },
        ],
        positionCodes: {
          prop: "positionCodes",
          label: `authorization.member.positionCodes`,
          width: "180",
          placeholder: `authorization.member.positionRule`,
          required: false,
        },
        loginInfo: [
          {
            prop: "loginId",
            label: `authorization.member.loginId`,
            width: "180",
            required: true,
            placeholder: `authorization.member.lengthRule`,
          },
          {
            prop: "loginPwd",
            label: `authorization.member.loginPwd`,
            width: "180",
            required: true,
            placehoder: `authorization.member.loginPwdRule`,
          },
          {
            prop: "effectiveDate",
            label: `authorization.member.effectiveDate`,
            width: "180",
            required: false,
            placeholder: `authorization.member.effectiveDateRule`,
          },
          {
            prop: "pwdExpDate",
            label: `authorization.member.pwdExpDate`,
            width: "180",
            required: false,
            placeholder: `authorization.member.pwdExpDateRule`,
          },
        ],
      },
    };
  },
  computed: {
    buttonAuth: function () {
      return this.$store.getters.auth.buttonAuth;
    },
  },
  methods: {
    deleteResourceGroup(items) {
      console.log(items);
      //弹框二次确认
      //删除抽屉里面的资源组
    },
    queryResourceGroup() {
      this.tableConfig2 = {
        table: [
          {
            prop: "name",
            label: `authorization.member.loginId`,
            width: "",
          },
          {
            prop: "ID",
            label: `authorization.member.ID`,
            width: "",
          },
          {
            prop: "email",
            label: `authorization.member.email`,
            width: "",
          },
          {
            prop: "job",
            label: `authorization.member.job`,
            width: "",
          },
          { prop: "status", label: `common.status`, width: "" },
        ],
      };
    },
    setDialog(v) {
      if (v) {
        //是保存或删除
        this.confirmDelete();
      }
      this.dialogFormVisible = false;
    },
    confirmDelete() {
      let arr = [];
      this.selectedItems.forEach((item) => {
        arr.push(item.id);
      });
      let data = { ids: arr };
      deleteMember(data).then((res) => {
        if (res.code == "AUTH_000000") {
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.query();
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    deleteItem() {
      //需要弹框二次确认
      this.dialogFormVisible = true;
    },
    addoredit(obj) {
      let data = obj;
      //新增的话做保存
      if (this.drawerMode == "add") {
        addUser(data).then((res) => {
          if (res.code == "AUTH_000000") {
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.changeMemberDrawer(false);
            this.query();
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        });
      } else {
        //编辑的话二次确认
        this.$alert(this.$t("common.confirmEdit"), this.$t("common.alert"), {
          confirmButtonText: this.$t("common.confirm"),
          callback: (val) => {
            if (val == "confirm") {
              updateUser(data).then((res) => {
                if (res.code == "AUTH_000000") {
                  this.$message({
                    type: "success",
                    message: res.msg,
                  });
                  this.changeMemberDrawer(false);
                  this.query();
                } else {
                  this.$message({
                    type: "error",
                    message: res.msg,
                  });
                }
              });
            }
          },
        });
      }
    },
    callBackAction(param) {
      this.selectedItems = param.selectedItems;
      this.formInline = param.formInline;
      if (param.event !== "handleSelectionChange") {
        this[param.event](param);
      }
    },
    changeMemberDrawer(v) {
      this.showMemberDrawer = v;
    },
    query() {
      let data = {
        currentPage: this.formInline.currentPage || 1,
        pageSize: this.formInline.pageSize || 10,
        condition: {
          vagueParam: this.formInline.inputKey || "",
        },
      };
      queryMember(data).then((res) => {
        this.tableData = res.data;
        this.$nextTick(() => {
          this.$refs.child.$refs.multipleTable.clearSelection();
        });
      });
    },
    add() {
      this.addoreditForm = {};
      this.changeMemberDrawer(true);
      this.drawerMode = "add";
      this.drawerTitle = this.$t(`authorization.member.addMemeberTitle`);
      this.formData = this.addForm;
    },
    edit() {
      if (this.selectedItems.length != 1) {
        this.$message({
          type: "info",
          message: this.$t(`authorization.member.onlyChooseOne`),
        });
        return;
      }
      let data = {
        id: this.selectedItems[0].id,
      };
      //动态请求详情
      queryMemberDetail(data).then((res) => {
        this.changeMemberDrawer(true);
        this.drawerMode = "edit";
        this.drawerTitle = this.$t(`authorization.member.editMemeberTitle`);
        this.formData = this.addForm;
        this.addoreditForm = res.data;
      });
    },
    remove() {
      if (this.selectedItems.length == 0) {
        this.$message({
          type: "info",
          message: this.$t(`authorization.member.onlyChooseOne`),
        });
        return;
      }
      this.deleteItem();
    },
    connect() {},
    export() {},
    connectResourceGroup() {
      if (this.selectedItems.length != 1) {
        this.$message({
          type: "info",
          message: this.$t(`authorization.member.onlyChooseOne`),
        });
        return;
      }
      //组织关联资源分组
      this.drawerMode = "connectResourceGroup";
      this.drawerTitle = this.$t(`common.connectResourceGroup`);
      this.showConnectDrawer = true;
      this.handelNode = this.selectedItems[0];
    },
    confirmConnect(val) {
      let arr = [];
      val.forEach((item) => {
        arr.push(item.resGroupCode);
      });
      //确认岗位关联资源分组relResGroup
      let data = {
        positionCode: this.handelNode.positionCode,
        rootOrgCode: this.handelNode.rootOrgCode,
        resGroupCodes: arr,
      };
      console.log(data);
      //去请求
      this.showConnectDrawer = false;
    },
    changeConnectDrawer(v) {
      this.showConnectDrawer = v;
    },
    addResourceGroup() {
      this.dialogFormVisible = true;
      this.dialogType = "normalType";
      (this.dialogTitle = this.$t(`common.add`)),
        (this.eventType = "addResourceGroup");
    },
  },
};
</script>
<style lang="less" scoped></style>
